import { BaseInterior } from './BaseInterior';
import { socketManager } from '../socket/SocketManager';

export class DealPointInterior extends BaseInterior {
  render(): void {
    this.drawRoom(0x3a3a3a, 0x555555);
    this.addExitButton();
    this.addTitle(this.building.name);

    const { width, height } = this.scene.scale;
    const dp = this.stateData?.dealPointInfo;

    if (!dp) {
      this.addLabel(80, height / 2 - 20, 'Ce point de deal n\'est pas encore configure.', '#ff9800', '14px');
      this.addLabel(80, height / 2 + 10, 'Achetez ce batiment pour commencer.', '#aaaaaa', '12px');
      this.drawFurniture(width, height);
      return;
    }

    const mainX = 80;
    let y = 100;

    this.addLabel(mainX, y, `Drogue: ${dp.drugType}`, '#ffb347', '18px');
    y += 35;

    this.addLabel(mainX, y, `Prix actuel: $${dp.pricePerUnit}/u`, '#ffffff', '16px');
    y += 30;

    this.addLabel(mainX, y, `Stock: ${dp.stockOnSite} unites`, '#aaaaaa', '14px');
    y += 40;

    // Price buttons
    this.addButton(mainX + 80, y, '[ +10% Prix ]', '#4caf50', () => {
      const newPrice = Math.round(dp.pricePerUnit * 1.1 * 100) / 100;
      socketManager.sendAction('SET_DEAL_PRICE', {
        dealPointId: dp.id,
        drugType: dp.drugType,
        pricePerUnit: newPrice,
      });
      this.refreshAfterAction();
    });
    y += 40;

    this.addButton(mainX + 80, y, '[ -10% Prix ]', '#ff9800', () => {
      const newPrice = Math.round(dp.pricePerUnit * 0.9 * 100) / 100;
      socketManager.sendAction('SET_DEAL_PRICE', {
        dealPointId: dp.id,
        drugType: dp.drugType,
        pricePerUnit: newPrice,
      });
      this.refreshAfterAction();
    });
    y += 50;

    // Deposit stock button
    this.addButton(mainX + 80, y, '[ Deposer 10 unites ]', '#3a6bc4', () => {
      socketManager.sendAction('DEPOSIT_STOCK', {
        dealPointId: dp.id,
        drugType: dp.drugType,
        quantity: 10,
      });
      this.refreshAfterAction();
    });

    // Risk bar at bottom
    const statusY = height - 100;
    this.addLabel(mainX, statusY, 'Risque police:', '#aaaaaa');
    this.drawProgressBar(mainX + 120, statusY + 2, 150, 14, dp.riskLevel / 100, 0x333333,
      dp.riskLevel < 40 ? 0x4caf50 : dp.riskLevel < 70 ? 0xff9800 : 0xff4444);
    this.addLabel(mainX + 280, statusY, `${Math.floor(dp.riskLevel)}%`, '#cccccc');

    this.drawFurniture(width, height);
  }

  private drawFurniture(width: number, _height: number): void {
    this.graphics.fillStyle(0x5d4037, 1);
    this.graphics.fillRect(width - 250, 120, 120, 60);
    this.graphics.fillStyle(0x3e2723, 1);
    this.graphics.fillRect(width - 230, 200, 30, 30);
    this.graphics.fillRect(width - 170, 200, 30, 30);
    this.graphics.fillStyle(0xeeeeee, 0.8);
    this.graphics.fillRect(width - 240, 130, 25, 15);
    this.graphics.fillRect(width - 200, 135, 20, 12);
    this.graphics.fillRect(width - 160, 128, 22, 18);
  }

  private refreshAfterAction(): void {
    socketManager.onceActionResult(() => {
      socketManager.sendAction('ENTER_BUILDING', { buildingId: this.building.id });
    });
  }

  bindEvents(): void {
    // No persistent handlers — we use onceActionResult in button callbacks
  }
}
